module.exports = __webpack_public_path__ + "img/outlander2.adb7193c.jpeg";